import { render } from "./scheduleCreate.vue?vue&type=template&id=bc5b837c&scoped=true"
import script from "./scheduleCreate.vue?vue&type=script&lang=js"
export * from "./scheduleCreate.vue?vue&type=script&lang=js"

import "./scheduleCreate.vue?vue&type=style&index=0&id=bc5b837c&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5b837c"]])

export default __exports__